export const Endpoints = {
  postAuth: '/api/auth/realms/{0}/protocol/openid-connect/auth',

  postInitSignIn: '/api/v1/auth/{0}/login-actions/init-signin',
  postInitSignInWithPasskey: '/api/v1/auth/realms/{0}/login-actions/init-signin-passkey',
  postSignIn: '/api/v1/auth/{0}/protocol/openid-connect/signin',
  postSignInPasskey: '/api/v1/auth/realms/{0}/protocol/openid-connect/signin-passkey',

  postAuthResetCredentialsRoute: '/api/v1/auth/realms/{0}/login-actions/auth-reset-credentials',
  postInitResetCredentialsRoute: '/api/v1/auth/realms/{0}/login-actions/init-reset-credentials',
  postResetCredentialsRoute: '/api/v1/auth/realms/{0}/login-actions/reset-credentials',

  postRegistrationRoute: '/api/auth/realms/{0}/login-actions/registration',

  pageSignInPath: '/:realm/protocol/openid-connect/signin',
  pageSignIn2FaPath: '/:realm/protocol/openid-connect/signin2fa',
  pageResetCredentialsPath: '/:realm/login-actions/reset-credentials',
  pageRegistrationPath: '/:realm/login-actions/registration',
};